/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodRulesByIdQueryResponse, AuditReportsGetAodRulesByIdPathParams, AuditReportsGetAodRulesByIdQueryParams, AuditReportsGetAodRulesById401, AuditReportsGetAodRulesById403 } from "../models/AuditReportsGetAodRulesById";

export function getAuditReportsGetAodRulesByIdUrl(id: AuditReportsGetAodRulesByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-rules/${id}` as const }
  return res
}

/**
 * @summary Retrieve a single AodRule
 * {@link /audit-reports/v1/aod-rules/:id}
 */
export async function auditReportsGetAodRulesById(id: AuditReportsGetAodRulesByIdPathParams["id"], params?: AuditReportsGetAodRulesByIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetAodRulesByIdQueryResponse, ResponseErrorConfig<AuditReportsGetAodRulesById401 | AuditReportsGetAodRulesById403>, unknown>({ method : "GET", url : getAuditReportsGetAodRulesByIdUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}